import React from "react";
import "./AccountTypeNew.scss";
import Button from "../../UI/Button/Button";
import crown from "../../../assets/icons/crown.png";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { containerUrl, dashboardUrl } from "../../utils/constants";
import DeviceContext from "../../Services/identifyDevice";
import config from "../../../config/domain";

const AccountTypeNew = (props: any) => {
  // const history = useHistory();
  const navigate = useNavigate()
  const hideInvestment: boolean = config.hideInvestment;
  const [selectAccount, setSelectAccount] = React.useState<{
    selected: boolean;
    accounType: string;
  }>({ selected: false, accounType: "" });
  const setInvestmentProductCode = () => {
    // localStorage.setItem("productCode", "I");
    if (hideInvestment) {
      // history.push(containerUrl.registration + "?productCode=TD");
      navigate(containerUrl.registration + "?productCode=TD")
    } else {
      // history.push(containerUrl.registration + "?productCode=I");
      navigate(containerUrl.registration + "?productCode=I")
    }
  };
  const setAOPProductCode = () => {
    // localStorage.setItem("productCode", "TD");
    // history.push(containerUrl.registration);
    // history.push(containerUrl.registration + "?productCode=TD");
    navigate(containerUrl.registration + "?productCode=TD")
  };
  const getButtonText = () => {
    let buttonText = "Select Account to Open";
    if (selectAccount?.accounType == "TD" && selectAccount?.selected) {
      buttonText = "Open a Pro Account";
    } else if (selectAccount?.accounType == "I" && selectAccount?.selected) {
      buttonText = "Open a Starter Account";
    }
    return buttonText;
  };
  const getButtonClass = () => {
    let buttonClass = "pro-button-subsection-mobile";
    if (selectAccount?.accounType == "TD" && selectAccount?.selected) {
      buttonClass = "pro-button-subsection-mobile";
    } else if (selectAccount?.accounType == "I" && selectAccount?.selected) {
      buttonClass = "starter-button-subsection-mobile";
    }
    return buttonClass;
  };
  const handleSubmit = () => {
    if (selectAccount?.accounType == "TD" && selectAccount?.selected) {
      setAOPProductCode();
    } else if (selectAccount?.accounType == "I" && selectAccount?.selected) {
      setInvestmentProductCode();
    }
  };
  return (
    <>
      {DeviceContext()?.isMobile ? (
        <>
          {" "}
          <div className="accountTypesNew">
            <div className="main-section">
              <div className="main-heading-text">
                Choose which Wealth account you want to open?
              </div>
              <div className="subSection-Mobile">
                <div className="subsection-class">
                  <div className="Text-Section">
                    <span>Account</span>
                    <span className="mt-40 mb-40">Products</span>
                    <span className="mt-20 mb-20">Mutual Funds</span>
                    <div className="mt-20 mb-20">
                      <span>Insurance, Sovereign Gold</span>
                      <br />
                      <span>(SGB) Unlisted equity</span>
                    </div>

                    <span className="mt-20 mb-20">
                      Equity, Derivatives, ETFs and other exchange-traded
                      products
                    </span>
                    <span className="mt-20 mb-20">
                      IPO and other Primary markets offerings
                    </span>
                    <span className="mt-20 mb-20">Many more products</span>
                  </div>
                  <div
                    className={
                      hideInvestment
                        ? "round-section-one-new"
                        : "round-section-one round-section-one-corner"
                    }
                  >
                    <span className="pro-label">Pro</span>
                    <div className="pro-trans-section">
                      <span>Transact in 50+ wealth and equity products</span>
                    </div>
                    <div className="mr-10">
                      <span className="edel-icon-mobile">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                    </div>
                    <div className="mr-10 mt-50 mb-40">
                      <span className="edel-icon-mobile">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                    </div>
                    <div className="mr-10 mb-40" style={{ marginTop: "60px" }}>
                      <span className="edel-icon-mobile">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                    </div>
                    <div
                      className="mr-10 mt-40 mb-40"
                      style={{ marginTop: "70px" }}
                    >
                      <span className="edel-icon-mobile">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                    </div>
                    <div
                      className="mr-10 mt-40 mb-40"
                      style={{ marginTop: "20px" }}
                    >
                      <span className="edel-icon-mobile">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                    </div>
                  </div>
                  {!hideInvestment && (
                    <div className="round-section-two">
                      <span className="starter-label">Starter</span>
                      <span className="starter-trans-section">
                        Basic account for investing only
                      </span>
                      <div className="mr-10">
                        <span className="edel-icon-mobile-new">
                          <i className="edel-icon-tick" aria-hidden="true" />
                        </span>
                      </div>
                      <div className="mr-10 mt-50 mb-40">
                        <span className="edel-icon-mobile-new">
                          <i className="edel-icon-tick" aria-hidden="true" />
                        </span>
                      </div>
                      <div
                        className="mr-10 mb-40"
                        style={{ marginTop: "60px" }}
                      >
                        <span className="edel-icon-mobile-close-new">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                      </div>
                      <div
                        className="mr-10 mt-40 mb-40"
                        style={{ marginTop: "70px" }}
                      >
                        <span className="edel-icon-mobile-close-new">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                      </div>
                      <div
                        className="mr-10 mt-40 mb-40"
                        style={{ marginTop: "20px" }}
                      >
                        <span className="edel-icon-mobile-close-new">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="select-section">
                  <span className="select-section-label">Select More</span>
                  <div
                    className={
                      hideInvestment ? "pro-section-box-new" : "pro-section-box"
                    }
                  >
                    <button
                      type="button"
                      className={`rounded-box ${
                        selectAccount?.accounType == "TD" &&
                        selectAccount?.selected
                          ? "filled"
                          : ""
                      }`}
                      aria-pressed={selectAccount?.accounType == "TD" && selectAccount?.selected}
                      aria-label="Select Pro account"
                      onClick={() => {
                        setSelectAccount({
                          selected: true,
                          accounType: "TD",
                        });
                      }}
                    />
                  </div>
                  {!hideInvestment && (
                    <div className="starter-section-box">
                      <button
                        type="button"
                        className={`rounded-box ${
                          selectAccount?.accounType == "I" &&
                          selectAccount?.selected
                            ? "filled"
                            : ""
                        }`}
                        aria-pressed={selectAccount?.accounType == "I" && selectAccount?.selected}
                        aria-label="Select Starter account"
                        onClick={() => {
                          setSelectAccount({
                            selected: true,
                            accounType: "I",
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="button-section-mobile">
                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    btnName={getButtonText()}
                    disabled={
                      selectAccount?.accounType == "" &&
                      selectAccount?.selected == false
                    }
                    parentClassName={" button-class " + getButtonClass()}
                    type="button"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="accountTypesNew">
          <div className={hideInvestment ? "main-section-new" : "main-section"}>
            {/* <span className="backSection">
        <span className="edel-icon-back-arrow" aria-hidden="true" />
        Back
      </span> */}

            <div className="subsection">
              {hideInvestment && (
                <div className="starter-section-new-hide-investment"></div>
              )}
              <div className="pro-section">
                <div className="pro-header-title">
                  <h2>Wealth Pro</h2>
                </div>
                <div className="pro-header-sub-title">
                  <p>All-in-one account for trading & investing</p>
                </div>
                <div className="transaction-padding">
                  <div className="transact-section">
                    <div className="transact-section-label">
                      <p>Transact in 50+ wealth and equity products</p>
                    </div>
                  </div>
                </div>
                <ul className="sub-section-same">
                  <li className="left-align-section">
                    <span className="edel-icon-section">
                      <span className="edel-icon">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                      <span className="edel-icon-label">Mutual Fund</span>
                    </span>
                  </li>
                </ul>
                <ul className="sub-section-same">
                  <li className="left-align-section">
                    <span className="edel-icon-section">
                      <span className="edel-icon">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                      <span className="edel-icon-label">
                        Insurance, Sovereign Gold (SGB), Unlisted equity
                      </span>
                    </span>
                  </li>
                </ul>{" "}
                <ul className="sub-section-same">
                  <li className="left-align-section">
                    <span className="edel-icon-section display-flex-class">
                      <span className="edel-icon">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                      <div className="edel-icon-label-wrapper">
                        <span className="edel-icon-label">
                          Equity, Derivatives, ETFs and other exchange-traded
                        </span>
                        <span className="edel-icon-label-products">
                          products
                        </span>
                      </div>
                    </span>
                  </li>
                </ul>{" "}
                <ul className="sub-section-same">
                  <li className="left-align-section">
                    <span className="edel-icon-section">
                      <span className="edel-icon">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                      <span className="edel-icon-label">
                        IPO and other Primary markets offerings
                      </span>
                    </span>
                  </li>
                </ul>{" "}
                <ul className="sub-section-same">
                  <li className="left-align-section">
                    <span className="edel-icon-section">
                      <span className="edel-icon">
                        <i className="edel-icon-tick" aria-hidden="true" />
                      </span>
                      <span className="edel-icon-label">
                        Many more products
                      </span>
                    </span>
                  </li>
                </ul>
                <div className="button-section">
                  <Button
                    onClick={() => {
                      setAOPProductCode();
                    }}
                    btnName="Open a Pro Account"
                    disabled={false}
                    parentClassName=" button-class pro-button-subsection"
                    type="button"
                  />
                </div>
              </div>
              {!hideInvestment && (
                <div className="starter-section">
                  <div className="starter-header-title">
                    <h2>Wealth Starter</h2>
                  </div>
                  <div className="starter-header-sub-title">
                    <p>Basic account for investing only</p>
                  </div>
                  <div className="starter-transaction-padding">
                    <div className="starter-transact-section">
                      <div className="starter-transact-section-label">
                        <p>Invest in Mutual Funds and other products</p>
                      </div>
                    </div>
                  </div>
                  <ul className="sub-section-same starter-sub-section-same">
                    <li className="left-align-section">
                      <span className="edel-icon-section">
                        <span className="edel-icon">
                          <i className="edel-icon-tick" aria-hidden="true" />
                        </span>
                        <span className="edel-icon-label">Mutual Fund</span>
                      </span>
                    </li>
                  </ul>
                  <ul className="sub-section-same starter-sub-section-same">
                    <li className="left-align-section">
                      <span className="edel-icon-section">
                        <span className="edel-icon">
                          <i className="edel-icon-tick" aria-hidden="true" />
                        </span>
                        <span className="edel-icon-label">
                          Insurance, Sovereign Gold (SGB), Unlisted equity
                        </span>
                      </span>
                    </li>
                  </ul>{" "}
                  <ul className="sub-section-same-another sub-section-same-another-new">
                    <li className="left-align-section">
                      <span className="edel-icon-section display-flex-class">
                        <span className="edel-icon">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                        <div className="edel-icon-label-wrapper">
                          <span className="edel-icon-label">
                            Equity, Derivatives, ETFs and other exchange-traded
                          </span>
                          <span className="edel-icon-label-products">
                            products
                          </span>
                        </div>
                      </span>
                    </li>
                  </ul>{" "}
                  <ul className="sub-section-same-another sub-section-same-another-new">
                    <li className="left-align-section">
                      <span className="edel-icon-section">
                        <span className="edel-icon">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                        <span className="edel-icon-label">
                          IPO and other Primary markets offerings
                        </span>
                      </span>
                    </li>
                  </ul>{" "}
                  <ul className="sub-section-same-another sub-section-same-another-new">
                    <li className="left-align-section">
                      <span className="edel-icon-section">
                        <span className="edel-icon">
                          <i className="edel-icon-close" aria-hidden="true" />
                        </span>
                        <span className="edel-icon-label">
                          Many more products
                        </span>
                      </span>
                    </li>
                  </ul>
                  <div className="button-section">
                    <Button
                      onClick={() => {
                        setInvestmentProductCode();
                      }}
                      btnName="Open a Starter Account"
                      disabled={false}
                      parentClassName=" button-class starter-button-subsection"
                      type="button"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default AccountTypeNew;
